import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Typography,
} from '@mui/material';
import PropTypes from 'prop-types';

import { adjustPolicyUtilizationConfirmationModalStyle } from './adjust-policy-utilization-confirmation-modal-style';

function AdjustPolicyUtilizationConfirmationModal(props) {
  const {
    isOpen = false,
    onClose = () => {},
    onConfirm = () => {},
    claimId = '',
    changes = [],
    isSubmitting = false,
  } = props;

  const classes = adjustPolicyUtilizationConfirmationModalStyle();

  return (
    <Dialog maxWidth='sm' fullWidth open={isOpen} onClose={onClose}>
      <DialogTitle>
        <Typography className={classes.modalTitle}>Confirm Changes:</Typography>
      </DialogTitle>
      <DialogContent>
        <Typography className={classes.sectionTitle}>Claim</Typography>
        <Typography className={classes.claimIdValue}>{claimId}</Typography>

        <Divider className={classes.divider} />

        <Typography className={classes.sectionTitle}>Changes Made:</Typography>

        {changes.map(change => (
          <div key={change.key} className={classes.changeBlock}>
            <Typography className={classes.adjustmentLine}>
              {change.label} Adjustment: {change.adjustment}
            </Typography>

            <div className={classes.comparisonGrid}>
              <Typography className={classes.comparisonLabel}>
                Current {change.label}
              </Typography>
              <Typography className={classes.comparisonValue}>
                {change.current}
              </Typography>
              <Typography className={classes.comparisonLabel}>
                New {change.label}
              </Typography>
              <Typography className={classes.comparisonValue}>
                {change.updated}
              </Typography>
            </div>
          </div>
        ))}
      </DialogContent>
      <DialogActions>
        <div className={classes.buttonContainer}>
          <Button
            fullWidth
            disabled={isSubmitting}
            className={classes.confirmButton}
            onClick={onConfirm}
          >
            CONFIRM
          </Button>
          <Button
            fullWidth
            disabled={isSubmitting}
            className={classes.cancelButton}
            onClick={onClose}
          >
            CANCEL
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  );
}

AdjustPolicyUtilizationConfirmationModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  claimId: PropTypes.string,
  changes: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      label: PropTypes.string,
      adjustment: PropTypes.string,
      current: PropTypes.string,
      updated: PropTypes.string,
    })
  ),
  isSubmitting: PropTypes.bool,
};

export default AdjustPolicyUtilizationConfirmationModal;
